var map = {
	"./air-conditioner.svg": 1635,
	"./airplane.svg": 1636,
	"./airport.svg": 1637,
	"./approved.svg": 1638,
	"./aquapark.svg": 1639,
	"./arrow-answer-bubble.svg": 1640,
	"./arrow-back.svg": 1641,
	"./arrow-flight.svg": 1642,
	"./arrow-right-top.svg": 1643,
	"./arrow-right.svg": 1644,
	"./bar.svg": 1645,
	"./beach-surface-pebble.svg": 1646,
	"./beach-surface-platform.svg": 1647,
	"./beach-surface-sand-pebble.svg": 1648,
	"./beach-surface-sand.svg": 1649,
	"./beachsurface.svg": 1650,
	"./card.svg": 1651,
	"./check.svg": 1652,
	"./clock.svg": 1653,
	"./cvv.svg": 1654,
	"./double-arrow.svg": 1655,
	"./empty-hotel-map.svg": 1656,
	"./filters/clear-filters.svg": 1657,
	"./filters/filter-button.svg": 1658,
	"./filters/instant-confirm-colored.svg": 1659,
	"./filters/instant-confirm.svg": 1660,
	"./filters/search-distance.svg": 1661,
	"./filters/search-lift.svg": 1662,
	"./fire.svg": 1663,
	"./flight-direct-mobile.svg": 1664,
	"./flight-direct.svg": 1665,
	"./flight-direct__additional-mobile.svg": 1666,
	"./flight-direct__additional.svg": 1667,
	"./flight-transition-mobile.svg": 1668,
	"./flight-transition.svg": 1669,
	"./flight-transition__additional-mobile.svg": 1670,
	"./flight-transition__additional.svg": 1671,
	"./food.svg": 1672,
	"./free-cancellation-colored.svg": 1673,
	"./fuel-green.svg": 1674,
	"./fuel-white.svg": 1675,
	"./funicular.svg": 1676,
	"./gallery-empty.svg": 1677,
	"./garranty.svg": 1678,
	"./gender-female.svg": 1679,
	"./gender-male.svg": 1680,
	"./gender-unidentified.svg": 1681,
	"./gift.svg": 1682,
	"./glass.svg": 1683,
	"./gym.svg": 1684,
	"./hand-luggage.svg": 1685,
	"./heated-pool.svg": 1686,
	"./hold-luggage.svg": 1687,
	"./hotel-reply.svg": 1688,
	"./included-services.svg": 1689,
	"./included.svg": 1690,
	"./kids-club.svg": 1691,
	"./kids-menu.svg": 1692,
	"./kids-pool.svg": 1693,
	"./lightning.svg": 1694,
	"./lock.svg": 1695,
	"./logo.svg": 1696,
	"./lt-extra/bonus_insurance.svg": 1697,
	"./lt-extra/bonus_ivi.svg": 1698,
	"./luggage-wrapping.svg": 1699,
	"./man.svg": 1700,
	"./map-button.svg": 1701,
	"./map/collapse-arrows.svg": 1702,
	"./map/expand-arrows.svg": 1703,
	"./massage.svg": 1704,
	"./nanny.svg": 1705,
	"./only-lt-half.svg": 1706,
	"./parking.svg": 1707,
	"./payment-mir.svg": 1708,
	"./paymenttype.svg": 1709,
	"./plane-arrival.svg": 1710,
	"./plane.svg": 1711,
	"./private-beach.svg": 1712,
	"./rest_types/active.svg": 1713,
	"./rest_types/couples.svg": 1714,
	"./rest_types/family.svg": 1715,
	"./review-tab-selected.svg": 1716,
	"./sauna.svg": 1717,
	"./search-sorting.svg": 1718,
	"./searcher-empty-request.svg": 1719,
	"./searcher-filtered-empty.svg": 1720,
	"./sidebar-bottom-triangle.svg": 1721,
	"./sidebar-menu-active.svg": 1722,
	"./sign_additional.svg": 1723,
	"./ski-in-ski-out.svg": 1724,
	"./social-fb.svg": 1725,
	"./social-share.svg": 1726,
	"./social-vk.svg": 1727,
	"./special.svg": 1728,
	"./success_additional.svg": 1729,
	"./swimming-pool.svg": 1730,
	"./thumbs-up.svg": 1731,
	"./wave.svg": 1732,
	"./wifi.svg": 1733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1007;